import { useMemo, useState } from 'react'

import { PopupSizeContext, Sizes } from './use-popup-size-context'

export const PopupSizeProvider = ({ children }) => {
  const [sizes, setSizes] = useState<Sizes>({})

  const value = useMemo(() => ({ sizes, setSizes }), [sizes, setSizes])

  return <PopupSizeContext.Provider value={value}>{children}</PopupSizeContext.Provider>
}
